// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-0-1!../../../node_modules/postcss-loader/dist/cjs.js!../Modal/modal.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-0-1!../../../node_modules/postcss-loader/dist/cjs.js!../../overrides/venia-ui/components/Wishlist/WishlistDialog/wishlistDialog.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frequentlyOrderedModal-modalWrapper--tF {\n    overflow: auto;\n}\n.frequentlyOrderedModal-FOPnormalModal-5ip {\n    max-width: 40.4rem;\n    width: 100%;\n}\n.frequentlyOrderedModal-root-9gc {\n    width: 100%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": "frequentlyOrderedModal-modalWrapper--tF",
	"FOPnormalModal": "frequentlyOrderedModal-FOPnormalModal-5ip " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["normalModal"] + "",
	"root": "frequentlyOrderedModal-root-9gc " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["root"] + ""
};
export default ___CSS_LOADER_EXPORT___;
